import { createHandleChange } from "../../../utils/calculator/createHandleChange";
import { getInputWidth } from "../../../utils/calculator/getInputWidth";
import style from "../calculator.module.css";
function EditableSubTitleEvent(props) {
  const { formData, setFormData, statusMode } = props;
  const handleChange = createHandleChange(setFormData);
  return (
        <input

            type="text"
            name={"sub_title"}
            placeholder={"Sub-Titulo do Evento..."}
            value={formData["sub_title"]}
            onChange={handleChange}
            style={{
                minWidth: "200px",
                width: `${getInputWidth(formData["sub_title"])}px`,
                maxWidth: '80vw',
                transition: 'width 0.2s ease',
            }}
            className={`align-self-center sub-title-event form-control ${statusMode ? `${style.calculator_border_color_dark} ${style.calculator_text_dark_mode} ${style.calculator_bg_dark}` : ""}  `}
        />
  );
}
export {
  EditableSubTitleEvent
};